export var PdfViewerLayoutSinglePageClasses;
(function (PdfViewerLayoutSinglePageClasses) {
    PdfViewerLayoutSinglePageClasses["Layout"] = "sp-pdf-viewer__layout-single-page";
    PdfViewerLayoutSinglePageClasses["PageWrapper"] = "sp-pdf-viewer__layout-single-page__page-wrapper";
    PdfViewerLayoutSinglePageClasses["FocusedWrapper"] = "focused";
})(PdfViewerLayoutSinglePageClasses || (PdfViewerLayoutSinglePageClasses = {}));
export var PdfViewerLayoutSinglePageDataTypes;
(function (PdfViewerLayoutSinglePageDataTypes) {
    PdfViewerLayoutSinglePageDataTypes["PageWrapper"] = "pageWrapper";
})(PdfViewerLayoutSinglePageDataTypes || (PdfViewerLayoutSinglePageDataTypes = {}));
export var PdfViewerLayoutSinglePageAttributes;
(function (PdfViewerLayoutSinglePageAttributes) {
    PdfViewerLayoutSinglePageAttributes["DataType"] = "data-type";
    PdfViewerLayoutSinglePageAttributes["PageNumber"] = "data-page-number";
})(PdfViewerLayoutSinglePageAttributes || (PdfViewerLayoutSinglePageAttributes = {}));
//# sourceMappingURL=pdf-viewer-layout-single-page.type.js.map